import { GetResult, RootApiFilter, RootApiSort } from "@/api/types";
import { Column, DataRecord, Filter, Search, Sort } from "@/components/Table/Table";

export function searchAndFilterToRootApiFilter<R = DataRecord>({
  filter,
  search,
  columns,
}: {
  filter?: Filter;
  search?: Search;
  columns: Column<R>[];
}) {
  let filters: RootApiFilter = {};
  columns.forEach((column) => {
    if (search?.[column.key] || filter?.[column.key]) {
      filters[column.key] = [];
      if (search?.[column.key]) filters[column.key].push(search[column.key]);
      if (filter?.[column.key])
        filters[column.key] = [...filters[column.key], ...filter[column.key]];
    }
  });

  return filters;
}

export const sortToRootSort = (sort: Sort | undefined): RootApiSort => {
  return {
    column: sort?.key,
    order: sort?.order,
  };
};

export const filterSearchToGetFilter = (
  filter: Filter | undefined,
  search: Search | undefined
): Record<string, string> => {
  let totalFilter = { ...filter };

  Object.entries(search || []).forEach(([key, search]) => {
    if (!(key in totalFilter)) {
      totalFilter[key] = [];
    }
    totalFilter[key].push(search);
  });

  let stringFilter: Record<string, string> = {};
  Object.keys(totalFilter).forEach((key) => {
    stringFilter[key] = totalFilter[key].join(";");
  });

  return stringFilter;
};

export const sortToParam = (sort: Sort | undefined) => {
  if (!sort) return {};
  return {
    sort_by: sort.key,
    sort_order: sort.order,
  };
};

export function getResultToGetData(result?: GetResult): GetData {
  return {
    total_count: result?.total_rows || 0,
    error_count: result?.total_errors || 0,
    correct_count: result?.total_correct,
    ignored_count: result?.total_ignored,
    data: result?.result || [],
    status: result?.status === "SUCCESS" ? "success" : "failed",
  };
}

export interface GetData<R = DataRecord> {
  total_count?: number;
  complete_count?: number;
  correct_count?: number;
  incomplete_count?: number;
  out_of_scope_count?: number;
  duplicate_count?: number;
  error_count?: number;
  calculating_count?: number;
  ignored_count?: number;
  filter_options?: Filter;
  data: R[];
  status: "success" | "failed";
}

export interface Response {
  status: "success" | "failed";
}

export interface ExportResponse extends Response {
  url: string;
}
